import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Brain } from 'lucide-react';
import { EProgramIDs, EPrograms } from '../data/programs/index';
import { ERoutes } from '../routes/index';

export const programLinks = [
  {
    title: 'Fellowship Program in AI Engineering',
    subtitle: 'Become an AI Engineer who ships real AI apps — not just notebooks.',
    link: ERoutes.AI_ENGINEERING,
    icon: (
      <div className="flex h-full w-full items-center justify-center rounded-md bg-v5-green-100">
        <Brain size={20} color="#07634c" aria-hidden="true" />
      </div>
    ),
  },
  {
    title: EPrograms[EProgramIDs.FELLOWSHIP].title,
    subtitle:
      'Upskill and land your dream career as an AI-powered Full-Stack or Backend developer - Assured!',
    link: ERoutes.FELLOWSHIP,
    icon: (
      <StaticImage
        loading="lazy"
        src="../../images/placements/Icons/Fellowship.png"
        placeholder="blurred"
        alt="Crio.Do"
        imgStyle={{ objectFit: 'contain' }}
      />
    ),
  },
  {
    title: EPrograms[EProgramIDs.QA_AUTOMATION_TESTING].title,
    subtitle:
      'Get practical work experience of automation testing & get software testing roles in top companies- Assured!',
    link: ERoutes.QA_AUTOMATION_TESTING,
    icon: (
      <StaticImage
        loading="lazy"
        src="../../images/placements/Icons/QA.png"
        placeholder="blurred"
        alt="Crio.Do"
        imgStyle={{ objectFit: 'contain' }}
      />
    ),
  },
  {
    title: EPrograms[EProgramIDs.DATA_SCIENCE].title,
    subtitle:
      'Master the in-demand, AI-powered data analytics skills to land top data analyst roles - Assured!',
    link: ERoutes.DATA_SCIENCE,
    icon: (
      <StaticImage
        loading="lazy"
        src="../../images/placements/Icons/DataScience.webp"
        placeholder="blurred"
        alt="Crio.Do"
        imgStyle={{ objectFit: 'contain' }}
      />
    ),
  },
  {
    title: EPrograms[EProgramIDs.SYSTEM_DESIGN].title,
    subtitle:
      'Master advanced software development and design skills with hands-on experience in System Design - Assured!',
    link: ERoutes.SYSTEM_DESIGN,
    icon: (
      <StaticImage
        loading="lazy"
        src="../../images/SystemDesignIcon.webp"
        placeholder="blurred"
        alt="Crio.Do"
        imgStyle={{ objectFit: 'contain' }}
      />
    ),
  },
  {
    title: EPrograms[EProgramIDs.SKILLQ_FULL_STACK_DEVELOPMENT_PROGRAM].title,
    subtitle:
      'Gen-AI powered program that boosts your Skill Quotient with real-world experience in fullstack development preparing you for your dream job.',
    link: ERoutes.SKILLQ_FULL_STACK_DEVELOPMENT_PROGRAM,
    icon: (
      <StaticImage
        loading="lazy"
        src="../../images/placements/Icons/Fellowship.png"
        placeholder="blurred"
        alt="Crio.Do"
        imgStyle={{ objectFit: 'contain' }}
      />
    ),
  },
  {
    title: EPrograms[EProgramIDs.SKILLQ_DATA_ANALYTICS_PROGRAM].title,
    subtitle:
      'Gen-AI powered program that boosts your Skill Quotient with real-world experience in data analytics preparing you for your dream job.',
    link: ERoutes.SKILLQ_DATA_ANALYTICS_PROGRAM,
    icon: (
      <StaticImage
        loading="lazy"
        src="../../images/placements/Icons/Fellowship.png"
        placeholder="blurred"
        alt="Crio.Do"
        imgStyle={{ objectFit: 'contain' }}
      />
    ),
  },
  {
    title: EPrograms[EProgramIDs.SKILLQ_QA_AUTOMATION_PROGRAM].title,
    subtitle:
      'Gen-AI powered program that boosts your Skill Quotient with real-world experience in qa automation, preparing you for your dream job.',
    link: ERoutes.SKILLQ_QA_AUTOMATION_PROGRAM,
    icon: (
      <StaticImage
        loading="lazy"
        src="../../images/placements/Icons/SkillqQaAutomation.png"
        placeholder="blurred"
        alt="Crio.Do"
        imgStyle={{ objectFit: 'contain' }}
      />
    ),
  },
];

export const links = [
  { name: 'Hire from Crio', link: ERoutes.RECRUIT },
  { name: 'Masterclass', link: ERoutes.MASTERCLASS },
  { name: 'Projects', link: ERoutes.PROJECTS },
  { name: 'Blog', link: ERoutes.BLOG },
  { name: 'Placements', link: ERoutes.PLACEMENTS },
];

export const placementLinks = [
  {
    title: 'Placement Stats',
    subtitle:
      'Helping our Learners Get the Best Career Breakthroughs and into the Best Companies',
    link: ERoutes.PLACEMENTS,
    icon: (
      <StaticImage
        loading="lazy"
        src="../../images/placements/Icons/PlacementStats.png"
        placeholder="blurred"
        alt="Crio.Do"
        imgStyle={{ objectFit: 'contain' }}
      />
    ),
  },
  {
    title: 'Success Stories',
    subtitle:
      'Hear from some of our learners who took their careers to new heights',
    link: ERoutes.SUCCESS_STORIES,
    icon: (
      <StaticImage
        loading="lazy"
        src="../../images/placements/Icons/SuccessStories.png"
        placeholder="blurred"
        alt="Crio.Do"
        imgStyle={{ objectFit: 'contain' }}
      />
    ),
  },
];

export const resourcesLink = [
  {
    title: 'ROI Calculator',
    subtitle:
      'Calculate the returns on your educational investment with our ROI calculator',
    link: ERoutes.ROI,
    icon: (
      <StaticImage
        loading="lazy"
        src="../../images/placements/Icons/ROI.png"
        placeholder="blurred"
        alt="Crio.Do"
        imgStyle={{ objectFit: 'contain' }}
      />
    ),
  },
];
